<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'请输入广告名称',clearable:true,ischange:true,isinput:true,iskeydown:true}"
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true}
                        if(val.type=='change') {param.key=val.value;param.ischange=true}
                        if(val.type=='keydown') GetList();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcselect :option="{placeholder:'跳转类型',filterable:true,clearable:true,ischange:true,width:'160px'}"
                    :value="param.type"
                    :list="typelist"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            param.type=val.value;
                            param.ischange=true;
                            GetList();
                        }
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcselect :option="{placeholder:'是否显示',filterable:true,clearable:true,ischange:true,width:'140px'}"
                    :value="param.isshow"
                    :list="showlist"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            param.isshow=val.value;
                            param.ischange=true;
                            GetList();
                        }
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'添加Banner'}" @finish="$parent.JUMPVIEW({name:'AddBanner'})"/>
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" :ref="objloading">
        <el-table :data="list" stripe="true" empty-text="">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column label="广告图" align="center">
                <template #default="scope">
                    <wcimage :option="{size:'middle'}" :value="scope.row.url" />
                </template>
            </el-table-column>
            <el-table-column prop="name" label="广告名称" align="center"/>
            <el-table-column prop="typename" label="跳转类型" align="center"/>
            <el-table-column label="是否显示" align="center">
                <template #default="scope">
                    <el-switch
                        v-model="scope.row.isshow"
                        :active-value="1"
                        :inactive-value="0"
                        @change="ChangeShow(scope.row)"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="inputtime" label="添加时间" align="center"/>
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <div class="TTL-btn-info">
                        <wcbutton :option="{title:'编辑'}" @finish="EditBanner(scope.row.id)"/>
                        <wcbutton :option="{title:'删除',type:'del'}" @finish="DelBanner(scope.row.id)" class="left10"/>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-page TTL-page-right">
                <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetList();
                    }"
                />
            </div>
        </div>
    </div>
</template>

<script>
import INTERFACE_BANNER from '@/Interface/Shop/banner';
export default {
    components:{},
    data() {
        return {
            objloading:'banner',
            param: {
                key:'',
                type:'',
                isshow:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            typelist:[
                {id:0,name:'无跳转'},
                {id:1,name:'跳转宠物详情'},
            ],
            showlist:[
                {id:0,name:'不显示'},
                {id:1,name:'显示'},
            ],
        }
    },
    mounted() {
        this.OnloadMethod();
    },
    methods: {

        OnloadMethod() {
            this.GetList();
        },

        BrotherComponentIn(data) {
            if(data.isask) {
                this.GetList();
            }else if(data.reload) {

            }else {
                this.GetList();
            }
        },

        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_BANNER.GET_BANNER_LIST(this.param).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.param.rows=res.data.count;
                this.list=res.data.list;
            });
        },

        ChangeShow(row) {
            INTERFACE_BANNER.CHANGE_BANNER_SHOW({id:row.id,isshow:row.isshow}).then((res) => {
                if(res.status > 0) {
                    row.isshow=row.isshow==1 ? 0 : 1;
                    return false;
                }
            });
        },

        EditBanner(ids) {
            this.$parent.JUMPVIEW({name:'EditBanner',param:{ids:ids}});
        },

        DelBanner(ids) {
            this.$confirm.confirm(
                '删除后将无法在小程序首页展示，是否确定删除？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type:'warning'}
            ).then(()=> {
                INTERFACE_BANNER.DEL_BANNER({ids:ids}).then((res) => {
                    if(res.status > 0) return false;
                    this.param.ischange=true;
                    this.GetList();
                });
            }).catch(()=> {});
        },

        ChangePageLabel() {

        },

    },
}
</script>
<style scoped>
.TTL-btn-info {display:inline-flex;}
</style>
